<template>
  <div class="h-100">
    <div class="content-page p-3 pb-5 h-100">
      <b-row>
        <b-col
          cols="12"
          class="text-right"
          v-if="hasRight(Settings.Permission.Change) && hasRight('AlwWrite')"
        >
          <button
            class="btn btn-info"
            @click="initShiftType"
            v-b-modal.modal-shift
          >
            {{ `${this.t.t(dictEnum.LBL_Add)} ` }}
          </button>
        </b-col>
      </b-row>
      <b-row class="h-100">
        <b-col cols="12" class="h-100 pb-5">
          <div class="tab-content bg-white h-100">
            <div class="tab-pane active table-responsive color-table h-80">
              <b-table
                class="tableRecord"
                :items="tableData"
                :fields="fields"
                :current-page="currentPage"
                :per-page="perPage"
              >
                <template #cell(TimeFrom)="data">
                  {{ data.item.TimeFrom | moment("HH:mm") }}
                </template>
                <template #cell(TimeTo)="data">
                  {{ data.item.TimeTo | moment("HH:mm") }}
                </template>
                <template #cell(Color)="data">
                  <div
                    style="height: 20px"
                    :style="{
                      'background-color': data.item.Color
                    }"
                  ></div>
                </template>
                <template #cell(Action)="data">
                  <div>
                    <font-awesome-icon
                      icon="edit"
                      style="cursor:pointer"
                      v-if="hasRight(Settings.Permission.Change)"
                      v-b-modal.modal-shift
                      @click="editShift(data.item)"
                    />

                    <font-awesome-icon
                      icon="trash"
                      style="cursor:pointer"
                      v-if="hasRight('AlwDel')"
                      @click="deleteShift(data.item)"
                    />
                  </div>
                </template>
              </b-table>
            </div>
            <b-row
              no-gutters
              class="pt-3"
              style="position: absolute;bottom: 50px;"
            >
              <b-col cols="12">
                <b-pagination
                  first-number
                  last-number
                  limit="10"
                  v-model="currentPage"
                  :per-page="perPage"
                  :total-rows="tableData.length"
                ></b-pagination>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </div>

    <b-modal
      id="modal-shift"
      :title="mode == 'new' ? t.t(dictEnum.LBL_Add) : t.t(dictEnum.BTN_Update)"
      :ok-title="t.t(dictEnum.BTN_Submit)"
      :cancel-title="t.t(dictEnum.BTN_Cancel)"
      @ok="editOrAddShiftType"
    >
      <div class="p-3">
        <b-row class="my-1 no-gutters">
          <b-col sm="5">
            <b-input-group-prepend is-text>
              <span class="bg-white">{{ t.t(dictEnum.LBL_ShiftCode) }}</span>
            </b-input-group-prepend>
          </b-col>
          <b-col sm="7">
            <b-form-group class="font-weight-normal">
              <b-form-input
                id="dpShift"
                :placeholder="this.t.t(dictEnum.LBL_ShiftCode)"
                v-model="shiftType.ShiftCode"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="my-1 no-gutters">
          <b-col sm="5">
            <b-input-group-prepend is-text>
              <span class="bg-white">{{ t.t(dictEnum.LBL_Description) }}</span>
            </b-input-group-prepend>
          </b-col>
          <b-col sm="7">
            <b-form-group class="font-weight-normal">
              <b-form-input
                id="dpShift"
                :placeholder="this.t.t(dictEnum.LBL_Description)"
                v-model="shiftType.ShiftDesc"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="my-1 no-gutters">
          <b-col sm="5">
            <b-input-group-prepend is-text>
              <span class="bg-white">{{ t.t(dictEnum.LBL_TimeFrom) }}</span>
            </b-input-group-prepend>
          </b-col>
          <b-col sm="7">
            <b-form-group class="font-weight-normal">
              <b-form-input
                id="dpShift"
                type="time"
                :placeholder="this.t.t(dictEnum.LBL_TimeFrom)"
                v-model="shiftType.TimeFrom"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="my-1 no-gutters">
          <b-col sm="5">
            <b-input-group-prepend is-text>
              <span class="bg-white">{{ t.t(dictEnum.LBL_TimeTo) }}</span>
            </b-input-group-prepend>
          </b-col>
          <b-col sm="7">
            <b-form-group class="font-weight-normal">
              <b-form-input
                id="dpShift"
                type="time"
                :placeholder="this.t.t(dictEnum.LBL_TimeTo)"
                v-model="shiftType.TimeTo"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="my-1 no-gutters">
          <b-col sm="5">
            <b-input-group-prepend is-text>
              <span class="bg-white">{{ t.t(dictEnum.LBL_Color) }}</span>
            </b-input-group-prepend>
          </b-col>
          <b-col sm="7">
            <b-form-group class="font-weight-normal">
              <b-form-input
                type="color"
                :placeholder="this.t.t(dictEnum.LBL_Color)"
                v-model="shiftType.Color"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>
import moment from "moment";
import MenuRightSerivce from "@/service/MenuRightService";
import ShiftTypeService from "@/service/ShiftTypeService";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import SweetAlertService from "@/service/SweetAlertService";
import StoreGetter from "@/constants/StoreGetter";
import { ShiftType } from "@/model/ShiftType";
import DatePicker from "vue2-datepicker";
import { datePickerLang } from "@/constants/globalConstants";
import Settings from "../../constants/Settings";
export default {
  components: { DatePicker },
  computed: {
    t() {
      return t;
    }
  },
  data() {
    return {
      menuRights: { allRights: {}, rightsForThisMenu: {} },
      menuId: Settings.MenuID.MM_ShiftType,
      Settings: Settings,
      dictEnum: dictEnum,
      tableData: [],
      fields: [
        {
          key: "ShiftCode",
          label: t.t(dictEnum.LBL_ShiftCode),
          thStyle: "width:20%",
          thClass: "tableHeader"
        },
        {
          key: "ShiftDesc",
          label: t.t(dictEnum.LBL_Description),
          thStyle: "width:20%",
          thClass: "tableHeader"
        },
        {
          key: "TimeFrom",
          label: t.t(dictEnum.LBL_TimeFrom),
          thStyle: "width:20%",
          thClass: "tableHeader"
        },
        {
          key: "TimeTo",
          label: t.t(dictEnum.LBL_TimeTo),
          thStyle: "width:20%",
          thClass: "tableHeader"
        },
        {
          key: "Color",
          label: t.t(dictEnum.LBL_Color),
          thStyle: "width:10%",
          thClass: "tableHeader"
        },
        {
          key: "Action",
          label: t.t(dictEnum.BTN_Update),
          thStyle: "width:10%",
          thClass: "tableHeader"
        }
      ],
      currentPage: 1,
      perPage: 15,
      mode: "new",
      shiftType: new ShiftType(),
      lang: datePickerLang
    };
  },
  methods: {
    hasRight(key) {
      if (Object.keys(this.menuRights.allRights).length === 0) {
        return false;
      } else {
        return MenuRightSerivce.hasRightInMenu(
          this.menuRights.allRights,
          this.menuId,
          key
        );
      }
    },
    assignRights() {
      this.menuRights.allRights = this.$store.getters[StoreGetter.sysMenu];
      this.menuRights.rightsForThisMenu = this.menuRights.allRights.find(
        x => x.MenuID == this.menuId
      );
    },
    initShiftType() {
      this.mode = "new";
      this.shiftType = new ShiftType();
    },

    async getPerPage() {
      const tableEle = await document.getElementsByClassName("tab-pane");
      const tableHeight = tableEle[0].offsetHeight;
      const trEle = tableEle[0].children[0].children;
      if (trEle.length > 1) {
        const thHeight = trEle[0].offsetHeight;
        const tdHeight = trEle[1].children[0].offsetHeight;
        let page = (tableHeight - thHeight * 2) / tdHeight;
        this.perPage = page.toFixed(0);
      }
    },

    editShift(shiftType) {
      this.mode = "edit";
      shiftType.TimeFrom = moment(shiftType.TimeFrom).format("HH:mm");
      shiftType.TimeTo = moment(shiftType.TimeTo).format("HH:mm");
      this.shiftType = shiftType;
    },
    async deleteShift(shiftType) {
      const sweetAlertOptions = {
        title: this.t.t(dictEnum.WARN_Confirm),
        text: `${t.t(dictEnum.WARN_Delete)}`,
        cancelButtonText: this.t.t(dictEnum.BTN_Cancel),
        confirmButtonText: this.t.t(dictEnum.BTN_Confirm)
      };
      const result = await SweetAlertService.question(sweetAlertOptions);
      if (result.value) {
        const obj = {
          shift: {
            ShiftCode: shiftType.ShiftCode
          }
        };

        const response = await ShiftTypeService.deleteShiftType(obj);
        if (response.data.IsSuccess) {
          SweetAlertService.success("Success", response.data.Message);
          this.getDataTable();
        } else {
          SweetAlertService.warning("Warn", response.data.Message);
        }
      }
    },

    async editOrAddShiftType() {
      if (!this.shiftType.TimeFrom) {
        SweetAlertService.warning(
          "Warn",
          t.t(dictEnum.LBL_ShiftType) + t.t(dictEnum.WARN_IsRequired)
        );
        return;
      }

      if (!this.shiftType.ShiftDesc) {
        SweetAlertService.warning(
          "Warn",
          t.t(dictEnum.LBL_Description) + t.t(dictEnum.WARN_IsRequired)
        );
        return;
      }

      if (!this.shiftType.TimeFrom) {
        SweetAlertService.warning(
          "Warn",
          t.t(dictEnum.LBL_TimeFrom) + t.t(dictEnum.WARN_IsRequired)
        );
        return;
      }

      if (!this.shiftType.TimeTo) {
        SweetAlertService.warning(
          "Warn",
          t.t(dictEnum.LBL_TimeTo) + t.t(dictEnum.WARN_IsRequired)
        );
        return;
      }

      if (!this.shiftType.Color) {
        SweetAlertService.warning(
          "Warn",
          t.t(dictEnum.LBL_Color) + t.t(dictEnum.WARN_IsRequired)
        );
        return;
      }

      if (this.mode == "new") {
        this.shiftType.AddBy = this.$store.getters[StoreGetter.user].UserID;
      }

      this.shiftType.ModifyBy = this.$store.getters[StoreGetter.user].UserID;

      const obj = {
        shift: this.shiftType
      };

      const response =
        this.mode === "new"
          ? await ShiftTypeService.addShiftType(obj)
          : await ShiftTypeService.updateShiftType(obj);

      if (response.data.IsSuccess) {
        this.shiftType = new ShiftType();
        SweetAlertService.success("Success", response.data.Message);
        this.getDataTable();
      } else {
        this.shiftType = new ShiftType();
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },

    async getDataTable() {
      const obj = {};

      const response = await ShiftTypeService.getShiftType(obj);

      if (response.data.IsSuccess) {
        this.tableData = response.data.Data;
        this.getPerPage();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    }
  },
  mounted() {
    this.assignRights();
    this.getDataTable();
  }
};
</script>
<style scoped>
.input-group-text {
  background: white;
  border: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/S050000-MM/S050600-ShiftType.vue